import React, { useState } from "react";
export default function NewsletterSubscriber() {
  const [subscribers, setSubscribers] = useState([]);
  const [email, setEmail] = useState("");
  const [active, setActive] = useState("All");
  const [role, setRole] = useState("All");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  // Mock export and import handlers
  const handleExport = () => {
    alert("Exported to CSV successfully!");
  };
  const handleImport = (e) => {
    const file = e.target.files[0];
    if (file) {
      alert(`Imported subscribers from ${file.name}`);
    }
  };
  const handleSearch = () => {
    alert("Search applied! (Mock)");
  };
  const handleEdit = (email) => {
    alert(`Editing subscriber: ${email}`);
  };
  const handleDelete = (email) => {
    if (window.confirm(`Delete subscriber ${email}?`)) {
      setSubscribers((prev) => prev.filter((s) => s.email !== email));
    }
  };
  return (
    <div className="min-h-screen bg-gray-100 p-6">
      {/* Top header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold text-gray-800">
          Newsletter subscribers
        </h2>
        <div className="flex gap-2">
          <button
            onClick={handleExport}
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
          >
            Export to CSV
          </button>
          <label className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded cursor-pointer">
            Import from CSV
            <input
              type="file"
              accept=".csv"
              onChange={handleImport}
              className="hidden"
            />
          </label>
        </div>
      </div>
      {/* Search panel */}
      <div className="bg-white rounded shadow p-4 mb-6 border">
        <h3 className="text-lg font-semibold mb-3 flex items-center gap-2">
          <svg
            className="w-5 h-5 text-gray-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 21l-4.35-4.35M10 18a8 8 0 100-16 8 8 0 000 16z"
            />
          </svg>
          Search
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label className="block font-medium text-sm mb-1">
              Email <span className="text-blue-500">?</span>
            </label>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border rounded w-full p-2"
            />
          </div>
          <div>
            <label className="block font-medium text-sm mb-1">
              Start date <span className="text-blue-500">?</span>
            </label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="border rounded w-full p-2"
            />
          </div>
          <div>
            <label className="block font-medium text-sm mb-1">
              End date <span className="text-blue-500">?</span>
            </label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="border rounded w-full p-2"
            />
          </div>
          <div>
            <label className="block font-medium text-sm mb-1">
              Active <span className="text-blue-500">?</span>
            </label>
            <select
              value={active}
              onChange={(e) => setActive(e.target.value)}
              className="border rounded w-full p-2"
            >
              <option>All</option>
              <option>Active</option>
              <option>NoN Active</option>
            </select>
          </div>
          <div>
            <label className="block font-medium text-sm mb-1">
              Customer roles <span className="text-blue-500">?</span>
            </label>
            <select
              value={role}
              onChange={(e) => setRole(e.target.value)}
              className="border rounded w-full p-2"
            >
              <option>All</option>
              <option>Registered</option>
              <option>Administration</option>
               <option>Forum MOderators</option>
              <option>Guests</option>
              <option>Vendor</option>
            </select>
          </div>
        </div>
        <div className="mt-4 flex justify-center">
          <button
            onClick={handleSearch}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded"
          >
            Search
          </button>
        </div>
      </div>
      {/* Subscribers Table */}
      <div className="bg-white rounded shadow p-4 border">
        <div className="flex justify-between items-center mb-3">
          <p className="text-sm text-gray-600">
            Learn more about{" "}
            <a
              href="#"
              className="text-blue-600 hover:underline font-medium"
            >
              email campaigns
            </a>
          </p>
        </div>
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-100 border-b">
              <th className="p-2 text-left">Email</th>
              <th className="p-2 text-left">Active</th>
              <th className="p-2 text-left">Language</th>
              <th className="p-2 text-left">Subscribed on</th>
              <th className="p-2 text-left">Edit</th>
              <th className="p-2 text-left">Delete</th>
            </tr>
          </thead>
          <tbody>
            {subscribers.length === 0 ? (
              <tr>
                <td
                  colSpan="6"
                  className="text-center text-gray-500 p-4 italic border"
                >
                  No data available in table
                </td>
              </tr>
            ) : (
              subscribers.map((s) => (
                <tr key={s.email} className="border-b hover:bg-gray-50">
                  <td className="p-2">{s.email}</td>
                  <td className="p-2">{s.active ? "Yes" : "No"}</td>
                  <td className="p-2">{s.language}</td>
                  <td className="p-2">{s.date}</td>
                  <td className="p-2">
                    <button
                      onClick={() => handleEdit(s.email)}
                      className="text-blue-600 hover:underline"
                    >
                      Edit
                    </button>
                  </td>
                  <td className="p-2">
                    <button
                      onClick={() => handleDelete(s.email)}
                      className="text-red-600 hover:underline"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        {/* Pagination */}
        <div className="flex justify-between items-center mt-4 text-sm">
          <div className="flex items-center gap-2">
            <button className="px-3 py-1 border rounded">Previous</button>
            <button className="px-3 py-1 border rounded">Next</button>
          </div>
          <div>
            Show{" "}
            <select className="border rounded p-1">
              <option>15</option>
              <option>25</option>
              <option>50</option>
            </select>{" "}
            items
          </div>
        </div>
      </div>
      {/* Footer */}
      <div className="text-center text-gray-500 text-sm mt-6">
        Powered by{" "}
        <a
          href="https://www.routekart.com"
          target="_blank"
          rel="noreferrer"
          className="text-blue-600 hover:underline"
        >
          routekart
        </a>{" "}
        version 4.80.3
      </div>
    </div>
  );
}
